import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';
import NavPagesMenu from './NavPagesMenu';
import { CAL_BOOKING_URL } from '../config/calBookingUrl';
import { getLocaleFromPathname } from '../config/localeRoutes';
import { trackEvent, trackGoal } from './Matomo';
import './Header.css';

function Header() {
  const { t } = useTranslation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const isArticlesActive = location.pathname.startsWith('/articles');
  const locale = getLocaleFromPathname(location.pathname);
  const homePath = locale === 'en' ? '/en/' : '/';

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const isHome = location.pathname === '/' || location.pathname === '/en/';
    if (!isHome) {
      window.location.href = `${homePath}#${sectionId}`;
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        const headerHeight = 80;
        const elementPosition = element.offsetTop - headerHeight;
        window.scrollTo({
          top: elementPosition,
          behavior: 'smooth'
        });
      }
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <nav className="navbar" aria-label="Navigation principale">
        <div className="container">
          <div className="nav-wrapper">
            <Link to={homePath} className="logo" aria-label="Leagora : accueil">
              <span className="logo-text">Leagora</span>
            </Link>

            <button 
              className={`menu-toggle ${isMobileMenuOpen ? 'active' : ''}`}
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              aria-label={isMobileMenuOpen ? 'Fermer le menu' : 'Ouvrir le menu'}
              aria-expanded={isMobileMenuOpen}
              aria-controls="primary-navigation"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>

            <div className={`nav-content ${isMobileMenuOpen ? 'active' : ''}`} id="primary-navigation">
              <ul className="nav-menu">
                <li>
                  <LanguageSwitcher />
                </li>
                <li>
                  <a 
                    href="#fonctionnalites" 
                    className="nav-link"
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToSection('fonctionnalites');
                    }}
                  >
                    {t('nav.features')}
                  </a>
                </li>
                <li>
                  <a 
                    href="#solutions" 
                    className="nav-link"
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToSection('solutions');
                    }}
                  >
                    {t('nav.solutions')}
                  </a>
                </li>
                <li>
                  <NavPagesMenu onNavigate={() => setIsMobileMenuOpen(false)} />
                </li>
                <li>
                  <Link
                    to="/articles/"
                    className={`nav-link${isArticlesActive ? ' nav-link-active' : ''}`}
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    {t('nav.articles')}
                  </Link>
                </li>
                <li>
                  <a
                    href={CAL_BOOKING_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-primary btn-nav"
                    onClick={() => {
                      trackEvent('Booking', 'Click', 'Header nav');
                      trackGoal(1);
                      setIsMobileMenuOpen(false);
                    }}
                  >
                    {t('nav.contact')}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
}

export default Header;
